(() => {
  const initGallery = (root) => {
    if (!root || root.dataset.llGalleryReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-ll-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-ll-thumb]'));
    const stage = root.querySelector('.ll-gallery__stage');
    const status = root.querySelector('[data-ll-gallery-status]');
    if (!slides.length || !stage) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerTracking = false;

    const showSlide = (index, focusThumb = false) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
      if (status) status.textContent = (activeIndex + 1) + ' / ' + slides.length;
      if (focusThumb && thumbs[activeIndex]) thumbs[activeIndex].focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        showSlide(index);
      });
    });

    root.addEventListener('click', (event) => {
      const control = event.target.closest('[data-ll-gallery-prev], [data-ll-gallery-next]');
      if (!control || !root.contains(control)) return;
      event.preventDefault();
      event.stopPropagation();
      showSlide(activeIndex + (control.hasAttribute('data-ll-gallery-prev') ? -1 : 1));
    }, true);

    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });

    stage.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a, input, select, textarea')) return;
      pointerTracking = true;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      if (event.pointerType !== 'mouse') stage.setPointerCapture?.(event.pointerId);
    });
    stage.addEventListener('pointerup', (event) => {
      if (!pointerTracking) return;
      pointerTracking = false;
      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      if (Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
        showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
      }
    });
    stage.addEventListener('pointercancel', () => { pointerTracking = false; });

    root.dataset.llGalleryReady = 'true';
    showSlide(activeIndex);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-ll-product]')) initGallery(scope);
    scope.querySelectorAll?.('[data-ll-product]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();